import ENU from './ENU'
import VN from './VN'
import CHT from './CHT'

export default {
  ENU,
  VN,
  CHT
}
